new Vue({
  el: '#app-restoration-form',
  components: {
        'app-restoration-form-com': {
          props: ["terms", "title", "text_top", "text_bottom", "image", "overview_title", "overview_text", "contact_title", "contact_text", "popup_title", "popup_text", "success_title", "success_text", "success_text_2", "failed_title", "failed_text"],
          template: `
              <form class="product-form product-form-multi restauration margin-top" method="POST" >
                <div v-if="showModal" class="form-overlay"></div>
                <div v-if="showModal" class="addedModal">
                  <button class="btn-icon" @click.prevent="closeModal">
                    <svg width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon"><path d="M6.44929 5.99808L9.82609 2.61798C9.88566 2.55811 9.91908 2.47707 9.91902 2.39261C9.91896 2.30816 9.88544 2.22716 9.82579 2.16737C9.70639 2.04857 9.49608 2.04798 9.37548 2.16798L5.99958 5.54807L2.62249 2.16707C2.50249 2.04857 2.29219 2.04917 2.17279 2.16767C2.14315 2.19719 2.11969 2.23232 2.10377 2.271C2.08786 2.30968 2.0798 2.35115 2.08009 2.39298C2.08009 2.47818 2.11309 2.55798 2.17279 2.61708L5.54958 5.99778L2.17309 9.37878C2.1135 9.43874 2.08013 9.51988 2.0803 9.60441C2.08047 9.68894 2.11416 9.76995 2.17399 9.82968C2.23189 9.88697 2.31379 9.91998 2.39839 9.91998H2.40019C2.48509 9.91968 2.56699 9.88638 2.62369 9.82848L5.99958 6.44838L9.37668 9.82938C9.43638 9.88878 9.51619 9.92178 9.60079 9.92178C9.6426 9.92182 9.684 9.91361 9.72264 9.89763C9.76128 9.88164 9.79638 9.8582 9.82594 9.82864C9.85551 9.79907 9.87895 9.76397 9.89494 9.72533C9.91092 9.68669 9.91912 9.64529 9.91908 9.60348C9.91908 9.51858 9.88609 9.43848 9.82609 9.37937L6.44929 5.99808Z" fill="#5C5C5C"></path></svg>
                  </button>
                  <div>
                    <h3>{{popup_title}}</h3>
                    <p>{{popup_text}}</p>
                    <div class="flex flex-gap-x1 btn-wrapper">
                        <button class="btn btn-secondary" :disabled="!isProductValid || hasReachedMaxItems" @click.prevent="addItem">{{ t.addAnotherItem }}</button>
                        <button class="btn" :disabled="!isProductValid" @click.prevent="addItemAndNext">{{ t.continue }}</button>
                    </div>
                  </div>
                </div>
                <div v-if="currentStep === 0" class="step front-view">
                    <div class="col-text">
                        <h2 class="section-title">{{title}}</h2>
                        <div v-html="text_top"></div>
                        <button class="btn" @click.prevent="goToAddItem">{{ t.next }}</button>
                    </div>
                    <div class="col-img">
                        <img :src="image">
                    </div>
                </div>
                <div v-if="currentStep === 1" class="step step-1 step-furniture">
                    <ol class="progress-bar">
                        <li class="active">{{ t.stepAboutItem }} <span>{{ t.step1of3 }}</span></li>
                        <li :class="{ clickable: hasItems }" @click.prevent="goToStep(2)">{{ t.stepOverview }}</li>
                        <li :class="{ clickable: hasItems }" @click.prevent="goToStep(3)">{{ t.stepContact }}</li>
                    </ol>
                    <div class="grid-col-all">
                      <h3>{{ t.addOneAtATime }}</h3>
                      <p>
                          {{ itemName ? (itemType ? itemName + ' ' + itemType : itemName) : (itemType ? itemType : t.unnamedItem + ' ' + getDisplayIndex()) }}
                      </p>
                    </div>
                    <div class="col-input">
                        <div class="inputs">
                          <label class="col-span-2" :class="{ invalid: !validationState.item.type }">
                              <span class="label-text">{{ t.itemTypeLabel }}</span>
                              <span>
                                <input name="mobeltype__f_eks__sofa_" type="text" :placeholder="t.itemTypePlaceholder" v-model="itemType" :maxLength="maxLength" :title="t.pleaseFill" required>
                              </span>
                          </label>
                          <label class="col-span-2" :class="{ invalid: !validationState.item.name }">
                              <span class="label-text">{{ t.itemNameLabel }}</span>
                              <span>
                                <input name="evt__design__eller_producentnavn" type="text" :placeholder="t.itemNamePlaceholder" v-model="itemName" :maxLength="maxLength">
                              </span>
                          </label>
                          <label class="col-span-2" :class="{ invalid: !validationState.item.size }">
                              <span class="label-text">{{ t.sizeLabel }}</span>
                              <span>
                                <input name="mal" type="text" :placeholder="t.sizePlaceholder" v-model="itemSize" :maxLength="maxLength">
                              </span>
                          </label>
                          <label class="col-span-2 full-height" :class="{ invalid: !validationState.item.comment }">
                              <span class="label-text">{{ t.commentLabel }}</span>
                              <span class="full-height">
                                <textarea name="fort_l_os_hvad_du_onsker_lave" rows="5" :placeholder="t.commentPlaceholder" v-model="itemComment" :minLength="minLength" :maxLength="maxLengthTextArea" :title="t.pleaseFill" required></textarea>
                              </span>
                          </label>
                        </div>
                    </div>
                    <div>
                        <div>
                            <label :class="{ invalid: !validationState.item.images }">
                                <span class="label-text">{{ t.uploadLabel }}</span>
                            </label>
                            <div :class="['images-preview', { empty: imagePreviews.length === 0 }, { full: imagePreviews.length === 8 }]" @click.stop>
                                <div v-for="(image, index) in imagePreviews" :key="index" class="img-container">
                                    <img :src="image" :alt="t.fileStored">
                                    <button @click.stop.prevent="removeImage(index)" class="btn-icon">
                                        <svg class="icon" width="12" height="12" viewBox="0 0 12 12" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M6.44929 5.99808L9.82609 2.61798C9.88566 2.55811 9.91908 2.47707 9.91902 2.39261C9.91896 2.30816 9.88544 2.22716 9.82579 2.16737C9.70639 2.04857 9.49608 2.04798 9.37548 2.16798L5.99958 5.54807L2.62249 2.16707C2.50249 2.04857 2.29219 2.04917 2.17279 2.16767C2.14315 2.19719 2.11969 2.23232 2.10377 2.271C2.08786 2.30968 2.0798 2.35115 2.08009 2.39298C2.08009 2.47818 2.11309 2.55798 2.17279 2.61708L5.54958 5.99778L2.17309 9.37878C2.1135 9.43874 2.08013 9.51988 2.0803 9.60441C2.08047 9.68894 2.11416 9.76995 2.17399 9.82968C2.23189 9.88697 2.31379 9.91998 2.39839 9.91998H2.40019C2.48509 9.91968 2.56699 9.88638 2.62369 9.82848L5.99958 6.44838L9.37668 9.82938C9.43638 9.88878 9.51619 9.92178 9.60079 9.92178C9.6426 9.92182 9.684 9.91361 9.72264 9.89763C9.76128 9.88164 9.79638 9.8582 9.82594 9.82864C9.85551 9.79907 9.87895 9.76397 9.89494 9.72533C9.91092 9.68669 9.91912 9.64529 9.91908 9.60348C9.91908 9.51858 9.88609 9.43848 9.82609 9.37937L6.44929 5.99808Z" fill="#5C5C5C"/>
                                        </svg>
                                    </button>
                                </div>
                                <div id="drag-upload">
                                    <input name="uploaded_fil" type="file" id="images" @change="handleFileUpload" multiple accept="image/*"  :title="t.uploadTitle" :disabled="images.length >= 8">
                                    <div>
                                        <svg class="icon" width="44" height="29" viewBox="0 0 44 29" fill="none" xmlns="http://www.w3.org/2000/svg">
                                          <path d="M13.1111 11.7932L2 28.0038H42L27.1852 5.89844L21.2593 16.2143L13.1111 11.7932Z" fill="#5C5C5C" stroke="#5C5C5C" stroke-width="1.48148"/>
                                          <ellipse cx="7.18468" cy="4.42108" rx="4.44444" ry="4.42108" fill="#5C5C5C"/>
                                        </svg>
                                        <p>{{ t.uploadText }}</p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <div class="flex flex-gap-x1 btn-wrapper">
                            <button class="btn" :class="{ disabled: !isProductValid || hasReachedMaxItems }" @click.prevent="openModal">{{ t.save }}</button>
                        </div>
                        <p class="info-text">{{text_bottom}}</p>
                    </div>
                </div>
                <div v-if="currentStep === 2" id="step-overview" class="step step-2">
                    <ol class="progress-bar">
                        <li>{{ t.stepAboutItem }}</li>
                        <li class="active">{{ t.stepOverview }} <span>{{ t.step2of3 }}</span></li>
                        <li :class="{ clickable: hasItems }" @click.prevent="goToStep(3)">{{ t.stepContact }}</li>
                    </ol>
                    <div>
                        <h3>{{overview_title}}</h3>
                        <p>{{overview_text}}</p>
                        <div class="product-overview">
                            <div class="product" v-for="(item, index) in itemOverview" :key="index">
                                <div>
                                    <h4>{{item.name}} {{item.type}}</h4>
                                </div>
                                <div class="flex flex-gap-x1">
                                    <button class="btn-icon" @click.prevent="removeItem(index)">
                                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_171_6134)">
                                        <path d="M12.375 2.08594C6.6825 2.08594 2.0625 6.7526 2.0625 12.5026C2.0625 18.2526 6.6825 22.9193 12.375 22.9193C18.0675 22.9193 22.6875 18.2526 22.6875 12.5026C22.6875 6.7526 18.0675 2.08594 12.375 2.08594ZM17.5312 13.5443H7.21875V11.4609H17.5312V13.5443Z" fill="#5C5C5C"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_171_6134">
                                        <rect width="24.75" height="25" fill="white"/>
                                        </clipPath>
                                        </defs>
                                      </svg>
                                      <span>{{ t.delete }}</span>
                                    </button>
                                    <button class="btn-icon" @click.prevent="editItem(index)">
                                      <svg width="25" height="25" viewBox="0 0 25 25" fill="none" xmlns="http://www.w3.org/2000/svg">
                                        <g clip-path="url(#clip0_171_6133)">
                                        <path d="M3.34375 18.1901V21.3568C3.34375 21.6484 3.57062 21.8776 3.85938 21.8776H6.99437C7.12844 21.8776 7.2625 21.8255 7.35531 21.7214L18.6166 10.3568L14.7494 6.45052L3.49844 17.8151C3.39531 17.9193 3.34375 18.0443 3.34375 18.1901ZM21.6072 7.33594C22.0094 6.92969 22.0094 6.27344 21.6072 5.86719L19.1941 3.42969C18.7919 3.02344 18.1422 3.02344 17.74 3.42969L15.8528 5.33594L19.72 9.24219L21.6072 7.33594Z" fill="#5C5C5C"/>
                                        </g>
                                        <defs>
                                        <clipPath id="clip0_171_6133">
                                        <rect width="24.75" height="25" fill="white" transform="translate(0.25)"/>
                                        </clipPath>
                                        </defs>
                                      </svg>
                                      <span>{{ t.edit }}</span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="flex flex-gap-x1 btn-wrapper">
                        <button class="btn btn-secondary" :disabled="hasReachedMaxItems" @click.prevent="goToAddItem">{{ t.addItem }}</button>
                        <button class="btn" :disabled="!hasItems" @click.prevent="goToContactSlide">{{ t.next }}</button>
                    </div>
                </div>
                <div v-if="currentStep === 3 && !isLoading" id="step-contact" class="step step-3">
                    <ol class="progress-bar">
                        <li>{{ t.stepAboutItem }}</li>
                        <li :class="{ clickable: hasItems }" @click.prevent="goToStep(2)">{{ t.stepOverview }}</li>
                        <li class="active">{{ t.stepContact }} <span>{{ t.step3of3 }}</span></li>
                    </ol>
                    <div>
                        <h3>{{contact_title}}</h3>
                        <p>{{contact_text}}</p>
                        <div class="col-contact-input">
                            <label :class="{ invalid: !validationState.name }">
                                <span class="label-text">{{ t.nameLabel }}</span>
                                <span>
                                  <input autocomplete="name" name="firstname" type="text" :placeholder="t.namePlaceholder" :title="t.pleaseFill" required v-model="contactInfo.name">
                                </span>
                            </label>
                            <label :class="{ invalid: !validationState.phone }">
                                <span class="label-text">{{ t.phoneLabel }}</span>
                                <span>
                                  <input autocomplete="tel" name="phone" type="tel" :placeholder="t.phonePlaceholder" :title="t.pleaseFill" required v-model="contactInfo.phone">
                                </span>
                            </label>
                            <label :class="{ invalid: !validationState.postalCode }">
                                <span class="label-text">{{ t.postalLabel }}</span>
                                <span>
                                  <input autocomplete="postal-code" name="postnummer" type="text" :placeholder="t.postalPlaceholder" :title="t.pleaseFill" required v-model="contactInfo.postalCode">
                                </span>
                            </label>
                            <label :class="{ invalid: !validationState.email }">
                                <span class="label-text">{{ t.emailLabel }}</span>
                                <span>
                                  <input autocomplete="email" name="email" ref="emailInput" type="email" :placeholder="t.emailPlaceholder" :title="t.pleaseFill" required v-model="contactInfo.email">
                                </span>
                            </label>
                            <label id="dataconsent" class="label-checkbox"  :class="{ invalid: !validationState.dataConsent }">
                                <span>
                                  <input name="jeg_accepterer_vilkar_og_betingelser" type="checkbox" :title="t.pleaseCheck" required v-model="hasDataConsent">
                                </span>
                                <span>{{ t.iAccept }} <a :href="terms" target="_blank">
                                  {{ t.termsAndConditions }}
                                </a></span>
                            </label>
                        </div>
                        <div class="flex flex-gap-x1 btn-wrapper">
                            <button class="btn btn-secondary" :disabled="isLoading" @click.prevent="goToOverviewSlide">{{ t.previous }}</button>
                            <button type="submit" class="btn" :class="{ disabled: isLoading || !isFormValid }" @click.prevent="submitForm">
                              <span>{{ t.send }}</span>
                            </button>
                        </div>
                    </div>
                </div>
                <div v-if="isLoading" id="step-final" class="step">
                    <div class="spinner"></div>
                    <p>{{ t.loadingText }}</p>
                </div>
                <div v-if="currentStep === 4" id="step-final" class="step">
                    <h3>{{success_title}}</h3>
                    <p>{{success_text}}</p><br>
                    <p class="bold">{{success_text_2}}</p>
                    <button class="btn" @click="goToAddItem">{{ t.sendNewMessage }}</button>
                </div>
                <div v-if="currentStep === 5" id="step-error" class="step">
                    <h3>{{failed_title}}</h3>
                    <p>{{failed_text}}</p>
                    <button class="btn" @click="goToOverviewSlide">{{ t.tryAgain }}</button>
                </div>
            </form>
          `,
          data() {
            return {
              maxLength: 45,
              maxLengthTextArea: 380,
              minLength: 10,
              itemName: '',
              itemType: '',
              itemSize: '',
              itemComment: '',
              itemOverview: [],
              images: [], 
              imagePreviews: [],
              contactInfo: {
                  name: '',
                  phone: '',
                  postalCode: '',
                  email: ''
              },
              hasDataConsent: false,
              currentStep: 0,
              editingIndex: null,  
              maxItems: 4,
              isLoading: false,
              showModal: false,
              validationState: {
                  name: true,
                  phone: true,
                  postalCode: true,
                  email: true,
                  dataConsent: true,
                  item: {
                    name: true,
                    type: true,
                    size: true,
                    comment: true,
                    images: true
                  }
              }
            }
          },
          computed: {
              isProductValid() {
                  const itemName = this.itemName.trim().length <= this.maxLength;
                  const itemType = this.itemType != '' && this.itemType.trim().length <= this.maxLength;
                  const itemComment = this.itemComment.trim().length >= this.minLength && this.itemComment.trim().length <= this.maxLengthTextArea;
                  const hasRequiredFields = itemType && itemComment;

                  const itemSize = this.itemSize.trim().length <= this.maxLength;
                  const hasImages = this.images.length > 0 && this.imagePreviews.length > 0;
      
                  return hasRequiredFields && itemSize && itemName && hasImages;
              },
              isFormValid(){
                  const isEmailValid = this.$refs.emailInput?.checkValidity(); 
                  var hasRequiredFields = this.contactInfo.name != '' && this.contactInfo.phone != '' && this.contactInfo.postalCode != '' && this.contactInfo.email != '' && isEmailValid && this.hasDataConsent;
                  return hasRequiredFields;
              },
              hasReachedMaxItems() {
                  if (this.currentStep === 1) {
                      return this.itemOverview.length >= this.maxItems - 1;
                  } else if (this.currentStep === 2) {
                      return this.itemOverview.length >= this.maxItems; 
                  }
                  return false;
              },
              hasItems() {
                  return this.itemOverview.length > 0;
              },
              t() {
                  // Strings come from locales/*.json via the {% render 'restoration-form-i18n' %}
                  // snippet (managed in the Shopify language editor / Translate & Adapt).
                  return window.RESTORATION_FORM_I18N || {};
              }
          },
          methods: {
            // Reference number shown in HubSpot and the receipt mail, e.g. SK-4821-26.
            // The server hands out random numbers it has not used before this year.
            async fetchTicketId(prefix) {
                try {
                    const controller = new AbortController();
                    const timer = setTimeout(() => controller.abort(), 5000);
                    const response = await fetch(`https://files.klassik.dk/ticketNumber.php?prefix=${prefix}`, { method: "POST", signal: controller.signal });
                    clearTimeout(timer);
                    const id = (await response.text()).trim();
                    if (response.ok && new RegExp(`^${prefix}-\\d{4}-\\d{2}$`).test(id)) {
                        return id;
                    }
                } catch (_) {}
                return this.localTicketId(prefix);
            },
            // Fallback when the server is unreachable: random, but not checked for duplicates.
            localTicketId(prefix) {
                const year = String(new Date().getFullYear()).slice(-2);
                return `${prefix}-${Math.floor(1000 + Math.random() * 9000)}-${year}`;
            },
            goToStep(stepIndex) {
                if (this.hasItems) {
                    this.currentStep = stepIndex;
                }
            },
            getDisplayIndex() {
                return this.editingIndex !== null ? this.editingIndex + 1 : this.itemOverview.length + 1;
            },
            validateFields() {
                if (this.currentStep === 1) {
                    this.validationState.item.name = this.itemName.trim().length <= this.maxLength;
                    this.validationState.item.type = this.itemType.trim().length > 0 && this.itemType.trim().length <= this.maxLength;
                    this.validationState.item.size = this.itemSize.trim().length <= this.maxLength;
                    this.validationState.item.comment = this.itemComment.trim().length >= this.minLength && this.itemComment.trim().length <= this.maxLengthTextArea;
                    this.validationState.item.images = this.images.length > 0 || this.imagePreviews.length > 0;
                  
                    return this.validationState.item.name && this.validationState.item.type && this.validationState.item.size && this.validationState.item.comment && this.validationState.item.images;
                }
        
                if (this.currentStep === 3) {
                  this.validationState.name = this.contactInfo.name.trim().length > 0;
                  this.validationState.phone = this.contactInfo.phone.trim().length > 0;
                  this.validationState.postalCode = this.contactInfo.postalCode.trim().length > 0;
                  
                  const emailInput = this.$refs.emailInput;
                  this.validationState.email = emailInput ? emailInput.checkValidity() : false;
              
                  this.validationState.dataConsent = this.hasDataConsent;
              
                  return this.validationState.name && this.validationState.phone && this.validationState.postalCode && this.validationState.email && this.validationState.dataConsent;
                }
        
                return false;
            },
              getCookie(cname) {
                  var name = cname + "=";
                  var decodedCookie = decodeURIComponent(document.cookie);
                  var ca = decodedCookie.split(';');
                  for(var i = 0; i <ca.length; i++) {
                      var c = ca[i];
                      while (c.charAt(0) == ' ') {
                      c = c.substring(1);
                      }
                      if (c.indexOf(name) == 0) {
                      return c.substring(name.length, c.length);
                      }
                  }
                  return null;
              },
              openModal() {
                if (this.validateFields()){
                  this.showModal = true;
                }
              },
              closeModal() {
                this.showModal = false;
              },
              goToAddItem(){
                  this.currentStep = 1;
              },
              goToOverviewSlide(){
                  this.currentStep = 2;
              },
              goToContactSlide(){
                  if(this.hasItems){
                      this.currentStep = 3;
                  }
              },
              addItem() {
                  if (!this.hasReachedMaxItems){
                      this.closeModal();
                      this.pushItemToOverview();
                      this.clearProductForm();
                  }
              },
              addItemAndNext() {
                  if(this.isProductValid){
                      this.closeModal();
                      this.pushItemToOverview();
                      this.clearProductForm();
                      this.currentStep = 2;
                  }
              },
              pushItemToOverview() {
                  let item = {
                      name: this.itemName,
                      type: this.itemType,
                      size: this.itemSize,
                      comment: this.itemComment,
                      images: this.images,
                      imagePreviews: this.imagePreviews
                  };
                  if (this.editingIndex === null) {
                      // Add new item
                      this.itemOverview.push(item);
                  } else {
                      // Update existing item
                      this.itemOverview.splice(this.editingIndex, 1, item);
                      this.editingIndex = null; 
                  }
              },
              clearProductForm() {
                  this.itemName = '';
                  this.itemType = '';
                  this.itemSize = '';
                  this.itemComment = '';
                  this.images = [];
                  this.imagePreviews = [];
              },
              clearForm() {
                  this.itemName = '';
                  this.itemType = '';
                  this.itemSize = '';
                  this.itemComment = '';
                  this.itemOverview = [];
                  this.images = [];
                  this.imagePreviews = [];
      
                  this.contactInfo.name = '';
                  this.contactInfo.phone = '';
                  this.contactInfo.postalCode = '';
                  this.contactInfo.email = '';
      
                  this.hasDataConsent = false;
                  this.currentStep = 1; 
                  this.editingIndex = null;
              },
              removeItem(index) {
                  this.itemOverview.splice(index, 1);
              },
              editItem(index) {
                  let item = this.itemOverview[index];
                  this.itemName = item.name;
                  this.itemType = item.type;
                  this.itemSize = item.size;
                  this.itemComment = item.comment;
                  this.images = item.images;
                  this.imagePreviews = item.imagePreviews;
                  this.editingIndex = index;
                  this.currentStep = 1;
              },
              handleFileUpload(event) {
                  const files = Array.from(event.target.files);
      
                  if (this.images.length + files.length > 8) {
                      alert(this.t.maxImagesAlert);
                      return;
                  }
      
                  files.forEach(file => {
                      this.images.push(file);
                      
                      const reader = new FileReader();
                      reader.onload = (e) => {
                          this.imagePreviews.push(e.target.result);
                      };
                      reader.readAsDataURL(file);
                  });
            
                  event.target.value = null;
              },
              removeImage(index) {
                  this.images.splice(index, 1);
                  this.imagePreviews.splice(index, 1);
              },
              async uploadImg(file) {
                const url = "https://files.klassik.dk/hubspotImageUpload.php";
    
                const formData = new FormData();
                if (file) {
                    formData.append('file', file);
                }
    
                try {
                    const response = await fetch(url, {
                        method: 'POST',
                        body: formData
                    });
    
                    if (!response.ok) {
                        throw new Error(`Upload failed`);
                    }
      
                    const responseText = await response.text();

                     if (responseText.includes("Error:")) {
                        throw new Error(`Upload failed`);
                    }
    
                    return responseText; 
                } catch (error) {
                    console.error('Error during upload');
                    throw error; 
                }
            },
             async submitForm() {
                  if (this.validateFields()) {
                      this.isLoading = true;
      
                      const url = "https://files.klassik.dk/hubspotSubmit.php?form=801e16d4-a74c-40c0-8f69-b6d64347f5ed";
                      let success = false;
              
                      var uniqueId = await this.fetchTicketId("IS");

                      const fields = [
                          { name: "ticketid", value: uniqueId },
                          { name: "firstname", value: this.contactInfo.name },
                          { name: "phone", value: this.contactInfo.phone },
                          { name: "email", value: this.contactInfo.email },
                          { name: "postnummer", value: this.contactInfo.postalCode },
                          { name: "jeg_accepterer_vilkar_og_betingelser", value: this.hasDataConsent }
                      ];

                      const context = {
                          hutk: this.getCookie("hubspotutk") || undefined,
                          pageUri: window.location.href,
                          pageName: document.title
                      };

                      let allImagesUploaded = true;

                      for (let index = 0; index < this.itemOverview.length; index++) {
                        const item = this.itemOverview[index];
                        const imageFields = [];
                        item.uploadedImages = [];

                        for (let image of item.images) {
                            try {
                                const response = await this.uploadImg(image);
                                imageFields.push({ name: `uploaded_fil_${index + 1}`, value: response }); 
                                item.uploadedImages.push(response);
                            } catch (error) {
                                console.error(`Failed to upload image for Produkt ${index + 1}`);
                                allImagesUploaded = false;
                                break; 
                            }
                        }

                        if (!allImagesUploaded) {
                            break;
                        }

                        fields.push(
                            { name: `evt__design__eller_producentnavn__restauration__${index + 1}`, value: item.name },
                            { name: `mobeltype__f_eks__sofa___restauration__${index + 1}`, value: item.type },
                            { name: `mal_${index + 1}`, value: item.size },
                            { name: `fort_l_os_hvad_du_onsker_lavet_${index + 1}`, value: item.comment },
                            ...imageFields
                        );
                      }

                      if (!allImagesUploaded) {
                          this.isLoading = false;
                          this.currentStep = 5; 
                          return;
                      }

                      const formData = { fields, context };
                        
                      try {
                          const response = await fetch(url, {
                              method: "POST",
                              // No Content-Type header: keeps this a CORS "simple request" (no preflight the server firewall could block).
                              body: JSON.stringify(formData)
                          });
          
                          if (response.ok) {
                              success = true;
                              console.log("Form submitted successfully");
                          } else {
                              const errorData = await response.json();
                              console.error("HubSpot form submission error");
                          }
                      } catch (error) {
                          console.error("Error submitting form");
                      } finally {
                        if (success) {
                            try {
                                await this.sendMail(uniqueId);
                            } catch (mailError) {
                                console.error("Error sending email", mailError);
                            }
                            this.clearForm();
                            this.isLoading = false;
                            this.currentStep = 4;
                        } else {
                            this.isLoading = false;
                            this.currentStep = 5;
                        }
                      }
                    };
              },
            async sendMail(id) {
                  return new Promise((resolve, reject) => { 
                      const siteKey = '6LfIaoIqAAAAAMz4xm9Jm4LvIX48wDDVaOwe-LoM';
                      const self = this;
                      const currentYear = new Date().getFullYear();
              
                      grecaptcha.ready(() => {
                          grecaptcha.execute(siteKey, { action: 'submit' }).then((token) => {
                              const itemsForEmail = this.itemOverview.map(item => ({
                                  item_design_name: item.name || '', 
                                  item_type: item.type || '',
                                  item_size: item.size || '',
                                  item_images: item.uploadedImages || [],
                                  item_comment: item.comment || ''
                              }));
                              
                              const payload = {
                                  email_template: "restoration",
                                  reciver_email: self.contactInfo.email,
                                  params: {
                                      current_year: currentYear,
                                      id: id,
                                      name: self.contactInfo.name,
                                      items: itemsForEmail
                                  }
                              };
                              const url = `https://files.klassik.dk/mails/index.php?token=${token}`;
              
                              fetch(url, {
                                  method: 'POST',
                                  body: JSON.stringify(payload),
                              })
                              .then((response) => {
                                  if (!response.ok) {
                                      throw new Error(`HTTP error! status: ${response.status}`);
                                  }
                                  return response;
                              })
                              .then((data) => {
                                  resolve(); 
                              })
                              .catch((error) => {
                                  console.error('Error occurred', error);
                                  reject(error); 
                              });
                          });
                      });
                  });
              }
          }
        }
      }
    });